import type { MonthSelectorState } from "@models/Schedule";
import { Text, IconButton, HStack } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

interface Props {
	handlePrevMonth: () => void;
	handleNextMonth: () => void;
	value: MonthSelectorState;
}

const MonthSelector = ({ handlePrevMonth, handleNextMonth, value }: Props) => {
	return (
		<HStack
			justifyContent={"center"}
			alignItems={"center"}
			height={"52.25px"}
			position={"sticky"}
			top={"0"}
			borderRight={"1px solid #DEDEDE"}
			borderBottom={"1px solid #DEDEDE"}
			bg={"#FFFFFF"}
		>
			<IconButton
				size={"xs"}
				isRound
				onClick={handlePrevMonth}
				aria-label="previous month"
				icon={<ChevronLeftIcon />}
			/>
			<Text
				width={"140px"}
				margin={0}
				textAlign={"center"}
				fontSize={"14px"}
				fontWeight={600}
				textTransform={"capitalize"}
			>
				{value.startDate.toLocaleString("sv-SE", { month: "long", year: "numeric" })}
			</Text>
			<IconButton size={"xs"} isRound onClick={handleNextMonth} aria-label="next month" icon={<ChevronRightIcon />} />
		</HStack>
	);
};

export default MonthSelector;
